var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEllipses = function SvgEllipses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.105 4.105a2.105 2.105 0 11-4.21 0 2.105 2.105 0 014.21 0zm0 7.895a2.105 2.105 0 11-4.21 0 2.105 2.105 0 014.21 0zM12 22a2.105 2.105 0 100-4.21A2.105 2.105 0 0012 22z",
    fill: "#9CA6AD"
  })));
};

export default SvgEllipses;